import { Table } from '@heroui/react'

import type { PosApprovalRequest } from '../types'
import { approvalOutcomeStyles, branchLabel, chipStyle, money, relativeTime } from './pos-format'
import { StatusChip } from './status-chip'

/**
 * What the tills actually did.
 *
 * Read-only, and not by omission: a manager who changes their mind denies the
 * next request. Rewriting a decided one would erase the minute in which a
 * refund was authorised, which is the minute the log exists for.
 */
export function ApprovalLogTable({ requests }: { requests: PosApprovalRequest[] }) {
  return (
    <Table>
      <Table.ScrollContainer>
        <Table.Content aria-label="Approval audit log">
          <Table.Header>
            <Table.Column id="time" isRowHeader>
              Time
            </Table.Column>
            <Table.Column id="branch">Branch</Table.Column>
            <Table.Column id="action">Action</Table.Column>
            <Table.Column id="amount">Amount</Table.Column>
            <Table.Column id="requester">Requester</Table.Column>
            <Table.Column id="approver">Approver</Table.Column>
            <Table.Column id="outcome">Outcome</Table.Column>
          </Table.Header>

          <Table.Body>
            {requests.map((request) => (
              <Table.Row key={request.id} id={request.id}>
                <Table.Cell>
                  <span className="text-muted tabular-nums">
                    {relativeTime(request.decidedAt)}
                  </span>
                </Table.Cell>

                <Table.Cell>
                  <span className="text-accent">{branchLabel(request.branch)}</span>
                </Table.Cell>

                <Table.Cell>{request.label}</Table.Cell>

                <Table.Cell>
                  <span className="tabular-nums">{money(request.amount)}</span>
                </Table.Cell>

                <Table.Cell>
                  {request.requestedBy ?? <span className="text-muted">—</span>}
                </Table.Cell>

                <Table.Cell>
                  {request.approvedBy ? (
                    <span className="text-accent">{request.approvedBy}</span>
                  ) : (
                    /* "— (offline)" rather than an empty cell. A till that
                       applied the policy alone and a manager who said no are
                       different events, and a log that conflated them cannot
                       answer why a queue stalled. */
                    <span className="text-muted">
                      — {request.decidedOffline && <span className="text-xs">(offline)</span>}
                    </span>
                  )}
                </Table.Cell>

                <Table.Cell>
                  <StatusChip style={chipStyle(approvalOutcomeStyles, request.outcome)} />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Content>
      </Table.ScrollContainer>
    </Table>
  )
}
